import { Component } from '@angular/core';

@Component({
  selector: 'version-bar',
  templateUrl: './version-bar.component.html',
  styleUrls: ['./version-bar.component.scss'],
})
export class VersionBarComponent {}
